import React from 'react'
import styled from 'styled-components'

/**
 * Button that looks like a link. Allows for onClick events on text without linking to href.
 */
export const LinkButton = styled.button`
  display: inline;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: var(--mediumdarkblue, var(--lightblue, inherit));
  text-decoration: none;
  cursor: pointer;
  font: inherit;
  font-weight: 500;
  text-align: inherit;
  
  :hover {
    color: var(--color-text-link-hover, var(--lighterblue, inherit));
    // text-decoration: underline;
  }
`

export default LinkButton
